<style scoped="scoped" lang="scss">
  .inputClass /deep/ .el-input__inner {
    height: 38px !important;
  }

  .inputClass /deep/ .el-input__icon {
    line-height: 20px !important;
  }

  .currentTable /deep/ .el-table__body .el-table__row {
    height: 75px !important;
  }

  ::v-deep .transparent-select .el-input__inner {
    border: none !important; // 去掉边框
    background-color: transparent; // 背景透明
    padding: 0 10px;
  }

  ::v-deep .work_hour_dialog_yt {
    .el-select {
      min-width: auto;
      width: 100%;
    }

    .el-input {
      min-width: auto;
      width: 100%;
    }
  }

  .center-form {
    width: 80%;
    margin: 0 auto;
  }
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"
      getUrl="/web/production/equipment/operation/record/page" getKey="rows" :columns="columns"
      @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select multiple type="equipmentAll" :queryFilter="e => e.belongId == null"
              :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('caozuoyonghu')">
            <yi_data_select :type="'customer_user'" :ids.sync="yt.conditions.operatorIds"
              :multiple="true"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shangjishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startTimeStart"
              :end.sync="yt.conditions.startTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('xiajishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.endTimeStart"
              :end.sync="yt.conditions.endTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'startTime desc' })">{{$t('chongzhi')}}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          @click="yt.showEditDialog('shangji', null, 'w1');setAddDefaultValue()"
          type="primary"
          v-if="utils.checkPower('web_production_management_equipment_operation_update')"
        >
          {{$t('shangji')}}
        </el-button>
        <el-button
          size="mini"
          @click="batchFinishWork()"
          type="primary"
          :disabled="checkDisabled"
          v-if="utils.checkPower('web_production_management_equipment_operation_allFinishWork')"
        >
          {{$t('piliangxiaji')}}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
          @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1"
            v-if="utils.checkPower('web_production_management_equipment_operation_finishWork') && !scope.row.endTime && scope.row.operatorId == store.state.user.id">
            <el-button type="text" @click="finishWork(scope.row)">
              {{$t('xiaji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.endTime">
            <el-button type="text" @click="yt.showEditDialog('baogongjilu', scope.row, 'w2');reportRecord(scope.row)">
              {{$t('baogongjilu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #gongshi="scope">
        <span>{{calcWorkHours(scope.row.startTime, scope.row.endTime)}}</span>
      </template>
    </yi_curd_table>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 上下机弹窗 -->
      <template v-if="yt.editObj.action == 'shangji' || yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="workForm" size="mini" :label-width="formLabelWidth">
          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_data_select multiple type="equipmentAll" :queryFilter="e => e.belongId == null"
              :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('caozuoyonghu')" required>
            <yi_data_select :type="'customer_user'" :ids.sync="yt.editObj.operatorId"
              :multiple="false"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('xiezuoren')">
            <yi_data_select :type="'customer_user'" :ids.sync="yt.editObj.collaboratorIds"
              :multiple="true"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" :autosize="{ minRows: 3, maxRows: 5 }"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shangjishijian')" v-if="action === 'shangji'">
            <el-date-picker v-model="startTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('xiajishijian')" v-if="action === 'xiaji'">
            <el-date-picker v-model="endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间"></el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
        <el-button :loading="yt.editObj.loading" size="mini"
          @click="yt.req('POST','/web/production/equipment/operation/record/create');clearSetValue()"
          type="primary">
						{{$t('baocun')}}
					</el-button>
      </span>
      </template>

      <template v-if="yt.editObj.action == 'baogongjilu'">
        <div class="dialog-scroller">
          <record :reportWork="yt.editObj" :chart="yt.editObj"></record>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">

  import record from './record.vue';
  import XLSX from 'xlsx';
  import XLSXStyle from 'xlsx-style';

  export default {
    name: 'web_production_management_equipment_operation_list',
    components: {
      record
    },
    data() {
      return {
        checkIds: [],
        checkDisabled: true,
        isShowWorkDialog: false,
        batchConfirmVisible: false,
        showRecord: false,
        action: '',
        title: '',
        selectedEquipmentId: [],
        selectedOperatorId: [],
        collaboratorIds: [],
        remark: '',
        startTime: null,
        endTime: null,
        saving: false,
        batchSaving: false,
        batchSelectedData: [],
        formLabelWidth: '120px',
        exportLoading: false,
        columns: [
          {
            label: 'xuanze',
            type: 'selection'
          },
          {
            label: 'shebeimingcheng',
            prop: 'equipment.name',
            width: 100

          },
          {
            label: 'caozuoyonghu',
            prop: 'operator.nickname',
            width: 140
          },
          {
            label: 'xiezuoren',
            prop: 'collaboratorNames'
          },
          {
            label: 'shangjishijian',
            prop: 'startTime',
            type: 'time',
            width: 160
          },
          {
            label: 'xiajishijian',
            prop: 'endTime',
            type: 'time',
            width: 160
          },
          {
            label: 'beizhu',
            prop: 'remark'
          },
          {
            label: 'gongshi',
            prop: 'workHours',
            type: 'slot'
          },
          {
            label: 'caozuo',
            type: 'slot',
            width: 150,
            fixed: 'right'
          }
        ]
      };
    },
    created() {
      setTimeout(() => {
        this.yt.conditions = {
          orderBy: 'startTime desc'
        };
        this.yt.get(1);
      }, 300);
    },
    methods: {
      clearSetValue() {
        this.checkIds = [];
        this.checkDisabled = true;
      },
      setAddDefaultValue() {
        if (this.store.state.user.id) {
          this.yt.editObj.operatorId = this.store.state.user.id;
        }
      },
      selectionChange(items) {
        this.checkIds = items.map(item => {
          return item.id;
        });
        if (this.checkIds.length > 0) {
          this.checkDisabled = false;
          for (let i = 0; i < items.length; i++) {
            if (items[i]['status'] == 2) {
              this.checkDisabled = true;
              return;
            }
          }
          this.checkDisabled = false;
        } else {
          this.checkDisabled = true;
        }
      },


      showWorkDialog(action) {
        this.action = action;
        this.title = action === 'shangji' ? '上机' : '下机';
        this.selectedEquipmentId = [];
        this.selectedOperatorId = [];
        this.collaboratorIds = [];
        this.remark = '';
        this.startTime = action === 'shangji' ? new Date() : null;
        this.endTime = action === 'xiaji' ? new Date() : null;
        this.isShowWorkDialog = true;
      },

      finishWork(row) {
        this.$confirm(`确认要为设备下机吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.http.post('/web/production/equipment/operation/record/finishWork', { ids: [row.id] })
            .then(res => {
              this.$message.success('下机成功');
              this.yt.get();
            })
            .catch(error => {
              this.$message.error(error);
            });
        });
      },

      reportRecord(row) {

      },

      batchFinishWork() {

        // 下机时间必须都为空，否则，提示用户：设备XXX，操作用户XXX，已下机，不可操作
        // 获取选中的行数据
        const selectedRows = this.yt.$refs.table.selection;

        // 校验选中的数据是否都未下机
        for (let i = 0; i < selectedRows.length; i++) {
          const row = selectedRows[i];
          if (row.endTime) {
            this.$message.error(`设备${row.equipment.name}，操作用户${row.operator.nickname}，已下机，不可操作`);
            return;
          }
        }

        this.$confirm(`确认要为批量下机吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids: this.checkIds
          };
          this.http
            .post('/web/production/equipment/operation/record/finishWork', params)
            .then(res => {
              this.utils.successMessage(this.$t(res.msg));
              this.checkDisabled = true;
              this.yt.get();
            })
            .catch(error => {
              this.auditSuccessLoading = false;
              this.utils.errorMessage(this.$t(error));
            });
        });
      },

      formatDateTime(timestamp) {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toLocaleString();
      },

      calcWorkHours(startTime, endTime) {
        if (!startTime || !endTime) return '';

        const start = new Date(startTime).getTime();
        const end = new Date(endTime).getTime();

        if (end <= start) return '0小时0分';

        const diffMs = end - start;
        const totalMinutes = Math.floor(diffMs / 1000 / 60);

        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        return `${hours}小时${minutes}分`;
      },
      exportExcel() {
        this.exportLoading = true;
        const data = this.yt.list || [];
        // 筛选出表头和prop
        const columns = this.columns.filter(c => c.type !== 'slot');
        let tableFirst = columns.filter(column => column.label !== 'xuanze').map(column => this.$t(column.label));

        // 顺序封装表格数据
        let tableArr = [];
        tableArr.push(tableFirst);
        for (let i = 0; i < data.length; i++) {
          let dataArr = [];
          for (let j = 0; j < columns.length; j++) {
            const column = columns[j];
            // 跳过selection列，避免数据错位
            if (column.type === 'selection') continue;

            const value = this.utils.getObjValueByLevelString(data[i], column.prop);
            const v = this.formatValue(column, value);
            dataArr.push(v);
          }
          tableArr.push(dataArr);
        }

        const worksheet = XLSX.utils.aoa_to_sheet(tableArr);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `上下机管理_导出_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
        this.exportLoading = false;
      },
      // 导出Excel时格式化值
      formatValue(column, value) {
        if (value == null) {
          return '';
        }
        switch (column.type) {
          case 'time':
            // 处理时间戳和日期字符串
            if (typeof value === 'number' && value > 0) {
              return this.dayjs(value).format('YYYY-MM-DD HH:mm:ss');
            } else if (typeof value === 'string') {
              // 尝试解析日期字符串
              const date = new Date(value);
              if (!isNaN(date.getTime())) {
                return this.dayjs(date).format('YYYY-MM-DD HH:mm:ss');
              }
            }
            return value;
          case 'dictionary_tag':
            return this.$t(this.$store.state.dictJson[column.key][value]);
          case 'dictionary':
            return this.$t(this.$store.state.dictJson[column.key][value]);
          default:
            return value;
        }
      },
    }
  };
</script>

<style scoped></style>

